import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { Sort } from "./sort";
import { Props } from "./types";
import styles from "./styles.scss";

function Toolbar({ sort, filter, setSort, setFilter }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.toolbar}>
      <div className={styles.section}>
        <p className={styles.title}>{t("zonesPage.sort.title")}</p>
        <div className={styles.sort}>
          <Sort sort={sort} setSort={setSort} />
        </div>
      </div>
      <div className={styles.section}>
        <p className={styles.title}>{t("zonesPage.filter.title")}</p>
        <div className={styles.filter}>
          <FilterMenu
            filter={filter}
            placeholder={t("zonesPage.filter.placeholderZones")}
            views={[
              "zones",
              "projects",
              "projectPortfolios",
              "projectsTags",
              "projectStatuses",
            ]}
            openedViews={["zones"]}
            setFilter={setFilter}
          />
        </div>
        <div className={styles.filter}>
          <FilterMenu
            filter={filter}
            placeholder={t("zonesPage.filter.placeholderResources")}
            views={["resources", "resourceTags", "groups"]}
            setFilter={setFilter}
          />
        </div>
      </div>
    </div>
  );
}

export { Toolbar };
